/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import React from 'react';

class BasicCountryCodeField extends React.Component {
	render() {
		return (
			<FormControl margin="normal" variant="outlined">
				<InputLabel id="demo-simple-select-outlined-label" />
				<Select
					className="ct-code bold-important"
					fullWidth
					id="ct-code"
					labelId="demo-simple-select-outlined-label"
					labelWidth={0}
					onChange={e => {
						this.props.setCountryCode(e);
					}}
					style={{ backgroundColor: '', height: 45 }}
					value={this.props.value}>
					<MenuItem value="+63">+63</MenuItem>
					{/* <MenuItem value="+91">+91</MenuItem>
					<MenuItem value="+44">+44</MenuItem>
					<MenuItem value="+34">+34</MenuItem> */}
				</Select>
			</FormControl>
		);
	}
}

export default BasicCountryCodeField;
